module.exports = __webpack_public_path__ + "media/images/gallery-image5-fab250fb3cb041a5d17bb250bc192201.webp";